// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapperSideNav_root__3w6AP","tabs":"LayoutWrapperSideNav_tabs__15ZA1","tab":"LayoutWrapperSideNav_tab__AgA6I"};